import { styled } from '~/app/components'
import { Typography } from '@yanolja-rnd/ya-com-core'

export const Title = styled.div`
  ${Typography('subtitle2').bold};
  color: ${({ theme }) => theme.color.gray900};
  margin-bottom: 0.4rem;
`
export const Subtitle = styled.div`
  ${Typography('body1').regular};
  color: ${({ theme }) => theme.color.gray900};
  margin-bottom: 1.2rem;

  @media (min-width: ${({ theme }) => theme.unit.PC_WIDTH}px) {
    font-weight: bold;
  }
`
export const RatePlanTitle = styled.div`
  ${Typography('body1').regular}
`
export const Options = styled.div`
  ${Typography('body2').regular};
  color: ${({ theme }) => theme.color.gray600};
  margin-top: 0.6rem;
`
export const Capacity = styled.div`
  display: flex;
  align-items: flex-start;
  ${Typography('body2').regular};
  color: ${({ theme }) => theme.color.gray600};
  margin-top: 1.6rem;
  & > svg {
    margin-right: 0.4rem;
    path {
      fill: ${({ theme }) => theme.color.gray600};
    }
  }
`
export const RoundedRect = styled.div`
  margin: 3.6rem auto 0;
  text-align: center;

  & > .text {
    border-radius: 1rem;
    padding: 0.3rem 1.2rem 0.2rem;
    margin-bottom: 1.2rem;
    height: 20px;
    ${Typography('body2').regular};
    color: ${({ theme }) => theme.color.gray600};
    background: ${({ theme }) => theme.color.gray100};
    display: inline-block;
  }
`
export const QRCode = styled.div`
  text-align: center;
  & > img {
    display: inline-block;
    width: 16rem;
    height: 16rem;
    margin: 0 auto 1.6rem;
  }
`
export const SelfCheckInNumber = styled.div`
  width: 100%;
  text-align: center;
  ${Typography('subtitle3').regular};
  color: ${({ theme }) => theme.color.gray900};
  margin-bottom: 3.2rem;
`
export const Time = styled.section`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: ${({ theme }) => theme.color.gray900};
  padding-bottom: 2rem;

  & > div {
    flex: 1;
  }

  & .title {
    ${Typography('body2').regular};
    color: ${({ theme }) => theme.color.gray600};
    margin-bottom: 0.8rem;
  }
  & .date {
    ${Typography('body1').regular};
  }
  & .time {
    ${Typography('headline3').regular};
  }
`
export const SelfCheckInPanel = styled.article`
  padding: 2.4rem 2rem 2rem;
  background: ${({ theme }) => theme.color.white};
  border-bottom: 1px solid ${({ theme }) => theme.color.gray200};
`
